import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import SoftAvatar from "components/SoftAvatar";
import { ComponentListItemIcon, ComponentListItemButton } from "../StyledComponents";
import { getLogoURL } from "layouts/Flow Designer/helpers/common";
import defaultConnectorIcon from "assets/images/connector-list-view.svg";
import { useSelector } from "react-redux";

const customStyles = {
  fontSize: "22px",
  minWidth: "40px",
  padding: "10px"
};

const ConnectorMenuItem = ({
  component,
  onDragStart = Function(),
  onDragEnd = Function(),
  addStep = Function(),
  allowEditWorkflow = false
}) => {
  const { id, name, logo, config_files } = component;
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);

  return (
    <ListItem title={name}>
      <ComponentListItemButton
        role={undefined}
        onClick={() => {
          addStep(component);
        }}
        dense
        sx={{ paddingLeft: 0, paddingRight: 2, borderRadius: "6px", maxWidth: 300 }}
        onDragStart={(event) => {
          onDragStart(event, "custom", {
            label: name,
            componentId: id,
            logo: logo + `?${new Date().getTime()}`,
            configFiles: config_files
          });
        }}
        onDragEnd={onDragEnd}
        draggable={allowEditWorkflow}
        disabled={!allowEditWorkflow || !currentSavedFlow}
      >
        <ComponentListItemIcon sx={{ ...customStyles }}>
          <SoftAvatar src={logo ? getLogoURL(logo) : defaultConnectorIcon} size="xs" />
        </ComponentListItemIcon>
        <ListItemText
          primary={name}
          primaryTypographyProps={{
            sx: { fontSize: "13px", overflow: "hidden", textOverflow: "ellipsis" }
          }}
        />
      </ComponentListItemButton>
    </ListItem>
  );
};

export default ConnectorMenuItem;
